import styled from "styled-components";
import {Button} from "react-bootstrap";
import SelectedImg from "../images/selected.png";
import MagnifierImg from "../images/magnifier.svg";
import AddressList from "./address/addressList";
import Page from "./pagination";
import {useEffect, useState,useMemo} from "react";
import ChainList from "./chainList";
import {addressList,chainListQuery} from "../api/graphqlAPI";
import {useLazyQuery,useQuery} from "@apollo/client";
import ChainListJson from "../api/chainList.json"
import debounce from "lodash.debounce";
import {useWeb3} from "../api/contracts";

const Box = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`
const BtnBox = styled(Button)`
  border-radius: 8px;
  width: 92px;
  height: 38px;
  background: #D51172;
  box-shadow: inset 0px 3px 3px 0px rgba(175,177,198,0.1);
  font-size: 16px;
  font-family: "AvenirNext-Medium";
  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
`
const MainContent = styled.div`
  flex-grow: 1;
  overflow: hidden;
`
const Btm = styled.div`
  margin-top: 20px;
`
const LftBox = styled.div`
  display: flex;
  align-items: center;
  .content{
  }
  .lftName{
    margin-left: 5px;
  }
`
const StatusBox = styled.ul`
  position: absolute;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #EDEEF3;
  left: 0;
  top:40px;
  width: 100%;
  padding: 10px 0;
  li{
    padding-left: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #2E396E;
    line-height: 30px;
    &:hover{
      background: #FBFBFA;
      cursor: pointer;
    }
  }
`


export default function Venture(){

    const {state} =useWeb3();
    const{ web3Provider,token} =state;
    const [showChain,setShowChain] = useState(false);
    const [currentChain,setCurrentChain] = useState(null);
    const [page,setPage] = useState(1);
    const [pageSize,setPageSize] = useState(10);
    const [total,setTotal] = useState(0);
    const [orderStr, setOrderStr ] = useState(null);
    const [sort_field, setSort_field ] = useState(null);
    const [chainList,setChainList] = useState([]);
    const [dataList,setDataList] = useState([]);
    const [keyword,setKeyword] = useState(null);
    const [ url, setUrl] = useState('');
    const [chainId, setChainid] = useState();

    const { data:chainListQ} = useQuery(chainListQuery);

    useEffect(()=>{
        if (chainListQ){
            setChainList(chainListQ.chains)
        }
    },[chainListQ])

    const [init, {data}] = useLazyQuery(addressList,{
        onCompleted: data => {
            setDataList(data.fpAddressList.data)
            setTotal(data.fpAddressList.total);
        },
        onError: error => {
            console.log(error)
        }
    });

    useEffect(()=>{
        if(window.location.host.indexOf('org')>-1){
            setUrl(window.BaseUrl.dev)
        }else{
            setUrl(window.BaseUrl.main)
        }

        const GetChain = async() =>{
            let chainInfo = await web3Provider.getNetwork();
            const { chainId } = chainInfo;
            setChainid(chainId)
        }

        GetChain()
    },[])

    const initInfo = () =>{
        init({
            variables:{
                page,
                size:pageSize,
                order:orderStr,
                sort_field:sort_field,
                search_addr:keyword,
                chainID:currentChain
            }
        })
    }
    useEffect(()=>{
        initInfo()
    },[page,pageSize,orderStr,sort_field,keyword,currentChain]);

    useEffect(() => {
        document.addEventListener("click", (e) =>{
            setShowChain(false);
        });
    }, [])


    const handleChain = (e) =>{
        e.nativeEvent.stopImmediatePropagation();
        setShowChain(true);
    }

    const handleSelectdChain = (num) =>{
        setCurrentChain(num)
    }

    const handlePage = (num) =>{
        setPage(num+1)
    }
    const handlePageSize= (num) =>{
        setPageSize(num);
    }
    const getIndex = (arr) =>{
        let ind
        for(let i = 0; i < arr.length; i++){
            if(arr[i] !== 0){
                ind= i;
            }
        }
        return ind;
    }
    const handleOrder = (order) =>{
        let i =  getIndex(order);

        let sort_field;
        let orderStr;
        //Total Deposit Amount(U) 0
        //Times 1
        switch (i){
            case 0:
                sort_field = "total_raised_amount_usdt";
                break;
            case 1:
                sort_field = "total_raised_times";
                break;
            default:break;
        }
        orderStr = order[i] ?(order[i] === 1 ? 'asc' :'desc'):null;
        setOrderStr(orderStr);
        setSort_field(sort_field);
    }

    const handleKeyword = (e) =>{
        setKeyword(e.target.value)
    }
    const debouncedChangeHandler = useMemo(() => {
        return debounce(handleKeyword, 300);
    }, []);


    return <Box>
        <Top>
            <LftBox>
                <div className="searchInput">
                    <img src={MagnifierImg} alt=""/>
                    <input type="text" placeholder="Address"  onChange={debouncedChangeHandler}/>
                </div>

                <div className="selectedBox">
                    {
                        showChain && <ChainList handleSelectdChain={handleSelectdChain} chainList={chainList} />
                    }
                    <div className="content" onClick={handleChain}>
                        {
                            !!currentChain &&<div>
                                {
                                    ChainListJson[currentChain]?.image && <img src={ChainListJson[currentChain].image} alt="" className="symbolImg"/>
                                }

                                <span className="lftName">{ChainListJson[currentChain]?.name}</span>
                            </div>
                        }
                        {
                            !currentChain && <span className="lftName"><span>All main-nets</span></span>
                        }
                        <img src={SelectedImg} alt=""/>
                    </div>
                </div>
            </LftBox>
            {/*<a href={`${url}/export_fund_participant_address?chain_id=${chainId}&token=${token}`} target="_blank" rel="noreferrer"><BtnBox>Export</BtnBox></a>*/}
            <a href={`${url}/export_fund_participant_address?token=${token}`} target="_blank" rel="noreferrer"><BtnBox>Export</BtnBox></a>
        </Top>
        <MainContent>
            <AddressList list={dataList} handleOrderArr={handleOrder}/>
        </MainContent>
        {
            !!total && <Btm>
                <Page itemsPerPage={pageSize} total={total} current={page-1} handleToPage={handlePage} handlePageSize={handlePageSize}/>
            </Btm>
        }

    </Box>
}